<template>
    <BizFiveXCreditsBanner
        :baseURL="baseURL"
        :http="psHttp"
        :locale="locale as FiveXCreditsBannerLocale"
        :enabled="isBannerEnabled"
        :currentRouteName="(route.name as string) ?? undefined"
        :hiddenRouteNames="hiddenRouteNames"
        @click="handleBannerClick"
    />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import psHttp from '@patsnap/common-ps-http';
import { FiveXCreditsBanner as BizFiveXCreditsBanner } from '@patsnap-biz/five-x-credits-banner';
import '@patsnap-biz/five-x-credits-banner/lib/style';
import { EUREKA_SERVICE_URI } from '@telecom/shared/domain-config/config';
import { useUserInfo } from '@telecom/shared/domain/permission/composables/use-user-info';
import { jumpToUsageLimitUpgradePage } from '@/features/usage-limit-modal';
import { getIsOversea } from '@telecom/shared/utils/environment';

type FiveXCreditsBannerLocale = 'cn' | 'en' | 'jp' | 'tw';

const route = useRoute();
const { locale } = useI18n();
const { isLogin, isFreeUser } = useUserInfo();

const baseURL = EUREKA_SERVICE_URI;
const isBannerEnabled = computed(() => isLogin.value && isFreeUser.value && getIsOversea());
const hiddenRouteNames = ['credits-price', 'pricing'];

function handleBannerClick() {
    jumpToUsageLimitUpgradePage({
        trigger_source: 'five_x_credits_banner',
        header_type: 'pricing_proactive_view',
        target: '_self',
        additionalQueryParams: {
            'price-range': 'five',
        },
    });
}
</script>
